import React from "react";

const Login = React.lazy(() => import("../pages/auth/Login"));
// const Dashboard = React.lazy(() => import("../pages/dashboard"));
const CategoryManagement = React.lazy(() => import("../pages/categoryManagement"));
const StoreManagement = React.lazy(() => import("../pages/storeManagement"));
const FinanceManagement = React.lazy(() => import("../pages/financeManagement"));
const FinanceDetail = React.lazy(() => import("../pages/financeManagement/FinanceDetail"));
const IngredientManagement = React.lazy(() => import("../pages/ingredientManagement"));
const StoreDetail = React.lazy(() => import("../pages/storeManagement/StoreDetail"));
const ProductManagement = React.lazy(() => import("../pages/productManagement"));
const OrderManagement = React.lazy(() => import("../pages/orderManagement"));
const OrderDetail = React.lazy(() => import("../pages/orderManagement/OrderDetail"));
const Error404 = React.lazy(() => import("../pages/Error404"));
const Error500 = React.lazy(() => import("../pages/Error500"));

export const ROUTES = {
  LOGIN: {
    path: "/auth/login",
    element: <Login />,
    isProtected: false,
  },
  // DASHBOARD: {
  //   path: "/dashboard",
  //   element: <Dashboard />,
  //   isProtected: true,
  // },
  CATEGORY_MANAGEMENT: {
    path: "/category-management",
    element: <CategoryManagement />,
    isProtected: true,
  },
  STORE_MANAGEMENT: {
    path: "/store-management",
    element: <StoreManagement />,
    isProtected: true,
  },
  STORE_DETAIL: {
    path: "/store-management/details/:storeId?",
    element: <StoreDetail />,
    isProtected: true,
  },
  FINANCE_MANAGEMENT: {
    path: "/finance-management",
    element: <FinanceManagement />,
    isProtected: true,
  },
  FINANCE_DETAIL: {
    path: "/finance-management/details/:storeId?",
    element: <FinanceDetail />,
    isProtected: true,
  },
  INGREDIENT_MANAGEMENT: {
    path: "/ingredient-management",
    element: <IngredientManagement />,
    isProtected: true,
  },
  PRODUCT_MANAGEMENT: {
    path: "/product-management",
    element: <ProductManagement />,
    isProtected: true,
  },
  ORDER_MANAGEMENT: {
    path: "/order-management",
    element: <OrderManagement />,
    isProtected: true,
  },
  ORDER_DETAIL: {
    path: "/order-management/details/:orderId?",
    element: <OrderDetail />,
    isProtected: true,
  },
  ERROR404: {
    path: "/404",
    element: <Error404 />,
    isProtected: false,
  },
  ERROR500: {
    path: "/500",
    element: <Error500 />,
    isProtected: false,
  },
}

export const routes = Object.values(ROUTES);